<ag-shr-change-log-detail-by-type
  [keysConfig]="hotelBookingInfoLookup"
  [changeLogs]="log"
  [showRemovedData]="false"
></ag-shr-change-log-detail-by-type>
